import * as i0 from '@angular/core';
import { InjectionToken, inject, PLATFORM_ID, Directive, Inject, ErrorHandler, Injectable, makeEnvironmentProviders, NgModule } from '@angular/core';
import { CookiesEnabledBaseManager, COOKIES_SSR_MANAGER } from '@noda-lib/utils/cookies';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
const REQUEST = new InjectionToken('REQUEST Token');
const RESPONSE = new InjectionToken('RESPONSE Token');
class CookiesEnabledSsrManager extends CookiesEnabledBaseManager {
  constructor(request) {
    super();
    this.request = request;
  }
  set(name, value, options) {}
  delete(name, sameSite, path, domain, secure) {}
  deleteAll(sameSite, path, domain, secure) {}
  getNativeCookies() {
    return this.request?.headers.cookie;
  }
}
function withSsrCookies() {
  return {
    provide: COOKIES_SSR_MANAGER,
    useFactory() {
      const request = inject(REQUEST, {
        optional: true
      });
      return new CookiesEnabledSsrManager(request);
    }
  };
}
let BrowserRenderDirective = /*#__PURE__*/(() => {
  class BrowserRenderDirective {
    constructor(platformId, templateRef, viewContainer) {
      this.platformId = platformId;
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
    }
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }
    static {
      this.ɵfac = function BrowserRenderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BrowserRenderDirective)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BrowserRenderDirective,
        selectors: [["", "ngBrowserRender", ""]]
      });
    }
  }
  return BrowserRenderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ServerRenderDirective = /*#__PURE__*/(() => {
  class ServerRenderDirective {
    constructor(platformId, templateRef, viewContainer) {
      this.platformId = platformId;
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
    }
    ngOnInit() {
      if (isPlatformServer(this.platformId)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }
    static {
      this.ɵfac = function ServerRenderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ServerRenderDirective)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ServerRenderDirective,
        selectors: [["", "ngServerRender", ""]]
      });
    }
  }
  return ServerRenderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EnLogLevel = /*#__PURE__*/function (EnLogLevel) {
  EnLogLevel["ERROR"] = "ERROR";
  return EnLogLevel;
}(EnLogLevel || {});
class ErrorMessage {
  constructor(message) {
    this.level = EnLogLevel.ERROR;
    this.timestamp = new Date().toJSON();
    this.message = null;
    const isExistStack = 'stack' in message;
    this.message = isExistStack ? String(message.stack) : JSON.stringify(message);
  }
}
let SsrLogger = /*#__PURE__*/(() => {
  class SsrLogger extends ErrorHandler {
    constructor() {
      super(...arguments);
      // eslint-disable-next-line @typescript-eslint/ban-types
      this.platformId = inject(PLATFORM_ID);
    }
    handleError(error) {
      if (isPlatformServer(this.platformId)) this.logServerError(error);
      super.handleError(error);
    }
    logServerError(error) {
      const msg = new ErrorMessage(error);
      console.error(JSON.stringify(msg));
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵSsrLogger_BaseFactory;
        return function SsrLogger_Factory(__ngFactoryType__) {
          return (ɵSsrLogger_BaseFactory || (ɵSsrLogger_BaseFactory = i0.ɵɵgetInheritedFactory(SsrLogger)))(__ngFactoryType__ || SsrLogger);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SsrLogger,
        factory: SsrLogger.ɵfac
      });
    }
  }
  return SsrLogger;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideSsrLogger() {
  return makeEnvironmentProviders([{
    provide: ErrorHandler,
    useClass: SsrLogger
  }]);
}
const imports = [BrowserRenderDirective, ServerRenderDirective];
let SsrModule = /*#__PURE__*/(() => {
  class SsrModule {
    static {
      this.ɵfac = function SsrModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SsrModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SsrModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return SsrModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BrowserRenderDirective, REQUEST, RESPONSE, ServerRenderDirective, SsrModule, provideSsrLogger, withSsrCookies };
